import { postQuery,  fetchData } from '../utils'
import { ApplicationState } from '../store';
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import * as moment from 'moment';
import { Table, Button, Select, Row, Col, message, DatePicker, Divider } from 'antd';
import { SearchOutlined, EyeOutlined, CloseCircleOutlined } from '@ant-design/icons/lib';
import * as React from "react";
import * as AuthStore from "../store/Auth";
const { RangePicker } = DatePicker;
const { Option } = Select;

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class Tracking extends React.Component<AuthProps>
{
    public state =
    {
        buttonText: 'Add',
        states: [],
        sites: [],
        statesLoaded: false,
        loading: false,
            loadingOth: false,
        viewTracking: false,
        confirmLoading: false,
        site: { Id: '', name: '', stateCode: '', lga: '', siteId: '', state: '' },
        state: { id: 0, name: '', code: '', sites: [] },
        trackings: [],
        searchObj:
        {
            from: '',
            to: '',
            stateId: 0,
            state: '',
            site: 0,
            siteId: '',
            siteName: '',
            stateName: '',
            itemsPerPage: 0,
            pageNumber: 0,
            indicator: '',
            ageBand: ''
        },
        tracker:
        {
            encounterId: '',
            patientId: '',
            sex: '',
            artStartDate: '',
            dateOfBirth: '',
            age: '',
            lastRegimen: '',
            lastRegimenLine: '',
            hospitalNumber: '',
            lastDrugPickup: '',
            lastDaysOfARVRefill: '',
            facility: '',
            stateCode: '',
            trackingEncounterDate: '',
            dateCreated: '',
            guardianOrTreatmentPartnerName: '',
            guardianTreatmentPartnerContactAddress: '',
            guardianTreatmentPartnerPhoneNumber: '',
            dateOfLastActualContactAppointment: '',
            dateOfMissedScheduledAppointment: '',
            lostToFollowUp: '',
            dateTracked: '',
            dateLTFU: '',
            dateCareTerminated: '',
            reasonForLostToFollowUp: '',
            reasonForTracking: '',
            datePatientContacted1: '',
            nameOfTracker1: '',
            modeOfCommunication1: '',
            personContacted1: '',
            reasonForDefaulting1: '',
            otherReasonForDefaulting1: '',
            datePatientContacted2: '',
            nameOfTracker2: '',
            modeOfCommunication2: '',
            personContacted2: '',
            reasonForDefaulting2: '',
            otherReasonForDefaulting2: '',
            datePatientContacted3: '',
            nameOfTracker3: '',
            modeOfCommunication3: '',
            personContacted3: '',
            reasonForDefaulting3: '',
            otherReasonForDefaulting3: '',
            datePatientContacted4: '',
            nameOfTracker4: '',
            modeOfCommunication4: '',
            personContacted4: '',
            reasonForDefaulting4: '',
            otherReasonForDefaulting4: '',
            datePatientContacted5: '',
            nameOfTracker5: '',
            modeOfCommunication5: '',
            personContacted5: '',
            reasonForDefaulting5: '',
            otherReasonForDefaulting5: '',
            careTerminated: '',
            facilityTransferredTo: '',
            causeOfDeath: '',
            otherCauseOfDeath: '',
            reasonDiscontinuedCare: '',
            discontinueCareOtherSpecified: '',
            dateReturnedToCare: '',
            nameOfContactTracker: '',
            trackingSignatureDate: '',
            referredFor: '',
            reasonForTermination: '',
        }
    };
    ////@ts-ignore
    async componentDidMount()
    {
        let el = this;
        let user = this.props.appUser;

        let sts = localStorage.getItem("states");
        let states = [];
        if (sts) states = JSON.parse(sts);
        if (user.stateCode && user.stateCode.length > 0)
        {
            var statex = states.filter(s =>
            {
                return s.stateCode.toLocaleLowerCase() === user.stateCode.toLocaleLowerCase();
            });
            if (statex.length > 0) {
                let { searchObj } = this.state;
                let state: any = states[0];
                this.setState({ state, searchObj });
            }
        }

        let statesLoaded = true;
        this.setState({ states, statesLoaded });
    }
    
    selectSite(value: any)
    {
        const { searchObj } = this.state;
        if (value) {
            searchObj.site = value.key;
            let sites: any = this.state.sites.filter(function (o: any) { return o.siteId === searchObj.site });
            if (sites.length > 0) searchObj.siteName = sites[0].name;
            this.setState({ searchObj, sites });
        }
    }

    selectState(value: any)
    {
        var el = this;
        if (!value)
        {
            return;
        }
        const { searchObj } = this.state;
        searchObj.site = 0;
        if (value) {
            let val = value.key;
            let states = this.state.states.filter(function (s: any) { return s.stateId === val });
            if (states.length > 0) {
                var state = states[0];
                el.setState({ state: state, searchObj: searchObj });
            }
        }
    }

    viewTracking(id)
    {
        let el = this;
        console.log(id);
        if (id === null || id < 1)
        {
            message.error("Invalid selection");
            return;
        }
        let tracks = this.state.trackings.filter(function (s: any) { return s.encounterId === id });
        if (tracks.length > 0)
        {
            el.setState({ tracker: tracks[0], viewTracking: true });
        }
    }

   ////@ts-ignore
    async gettrackings()
    {
        let el = this;
        const { searchObj } = el.state;

        if (searchObj.site === null || searchObj.site < 1)
        {
            message.error("Please select a Facility");
            return;
        }
               
        if (searchObj.from.length < 1)
        {
            message.error("Please select a Date Range");
            return;
        }
        if (searchObj.to.length < 1)
        {
            message.error("Please select a Date range");
            return;
        }

        let user = el.props.appUser;

        let payload =
        {
            from: el.state.searchObj.from,
            to: el.state.searchObj.to,
            site: searchObj.site ? searchObj.site : 0,
            siteId: searchObj.site ? searchObj.site : 0,
            state: (user.stateCode && user.stateCode.length > 0) ? user.stateCode : searchObj.state,
            siteName: searchObj.siteName,
            stateName: searchObj.stateName,
            stateId: searchObj.stateId ? searchObj.stateId : 0
        }

        let s = JSON.stringify(payload);
        el.setState({ loading: true });

        let res = await postQuery('/api/Stats/getTracking', s);
        el.setState({ loading: false });        
        el.setState({ trackings: res, loading: false }); 
    }

    dateRangeChange(a: any[], dateString: any) {
        let from = '';
        let to = '';
        if (dateString && dateString[0]) {
            from = dateString[0];
        }
        else {
            from = '';
        }

        if (dateString && dateString[1]) {
            to = dateString[1];
        }
        else {
            from = '';
        }
        const { searchObj } = this.state;
        searchObj.from = from;
        searchObj.to = to;
        this.setState({ searchObj });
    }

    exitTrack()
    {
        this.setState({
            viewTracking: false
        });
    }

    render()
    {        
        let el = this;
        const columns =
            [
                
                {
                    title: 'Patient Id',
                    dataIndex: 'patientId',
                    key: 'patientId',
                    render: (value: any, row: any, index: any) => <Button icon={<EyeOutlined />} danger key={row.id} onClick={() => el.viewTracking(row.encounterId)}>{value ? value : ''}</Button>
                },
                {
                    title: 'Hosp. NO',
                    dataIndex: 'hospitalNumber',
                    key: 'hospitalNumber',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Sex',
                    dataIndex: 'sex',
                    key: 'sex',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'ART Start Date',
                    dataIndex: 'artStartDate',
                    key: 'artStartDate',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'DOB',
                    dataIndex: 'dateOfBirth',
                    key: 'dateOfBirth',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Last Regimen',
                    dataIndex: 'lastRegimen',
                    key: 'lastRegimen',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                //{
                //    title: 'Regimen Line',
                //    dataIndex: 'lastRegimenLine',
                //    key: 'lastRegimenLine',
                //    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                //},
                // {
                //     title: 'Pickup Date',
                //     dataIndex: 'lastDrugPickup',
                //     key: 'lastDrugPickup',
                //     render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                //},
                //{
                //    title: 'Duration',
                //    dataIndex: 'lastDaysOfARVRefill',
                //    key: 'lastDaysOfARVRefill',
                //    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                //},
                {
                    title: 'Tracking Encounter Date',
                    dataIndex: 'trackingEncounterDate',
                    key: 'trackingEncounterDate',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Date Tracked',
                    dataIndex: 'dateTracked',
                    key: 'dateTracked',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Care Terminated',
                    dataIndex: 'careTerminated',
                    key: 'careTerminated',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Reason For Termination',
                    dataIndex: 'reasonForTermination',
                    key: 'reasonForTermination',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                }
            ];
       
        const { loading, loadingOth, state, states, searchObj, viewTracking, tracker } = this.state;                      
        let user = this.props.appUser;

        return (
            <div className="site-top">
                <Helmet>
                    <title>CDR - Client Tracking & Termination</title>
                </Helmet>
                <div className="custom-filter-dropdown">
                    <br/>
                    <Row style={{ marginTop: '2px' }}>
                        <Col span={24}>
                            <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}>Client Tracking & Termination</h4>
                        </Col>
                    </Row>
                    <br/>
                    <Row gutter={2}>
                        {!user.stateCode &&
                            <Col xs={24} sm={24} md={4} lg={4}>
                                <Select
                                labelInValue className="top-10-margin"
                                    showSearch
                                    optionFilterProp="children"
                                    disabled={loading}
                                    style={{ width: '98%' }}
                                    placeholder="Select State"
                                    onChange={(value) => this.selectState(value)}
                                >
                                    <Option key="" value="">-- Select State --</Option>
                                {states && states.map((s: any) => <Option key={s.stateId} value={s.stateId}>{s.stateName}</Option>)}
                                </Select>
                            </Col>
                        }
                        <Col xs={24} sm={24} md={6} lg={6}>
                            <Select
                                labelInValue className="top-10-margin"
                                showSearch
                                optionFilterProp="children"
                                disabled={loading}
                                style={{ width: '98%', float: 'right' }}
                                placeholder="Select Facility"
                                onChange={(value) => this.selectSite(value)}
                            >
                                <Option key="" value="">-- Select Facility --</Option>
                                {state.sites && state.sites.map((s: any) => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                            </Select>
                        </Col>
                        <Col xs={24} sm={24} md={6} lg={6}>
                            <RangePicker className="circl-radius top-10-margin" style={{ width: '98% !important', float: 'right' }}
                                //@ts-ignore
                                value={[searchObj.from.length > 0 ? moment(searchObj.from, "YYYY-MM-DD") : null, searchObj.to.length > 0 ? moment(searchObj.to, "YYYY-MM-DD") : null]}
                                allowClear={true} onChange={(a: any, b: any) => this.dateRangeChange(a, b)} disabled={loading}
                            />
                        </Col>
                        <Col xs={24} sm={24} md={4} lg={4}>
                            <Button disabled={loading} className="login-button top-10-margin" id="push-btn" loading={loading} key="submit" type="primary" size="large" onClick={() => this.gettrackings()} style={{ paddingRight: '40px', paddingLeft: '40px', float: 'right', width: '95%' }}>
                                <span id="buttonText">{!(loading && loadingOth) ? 'Fetch Data' : 'Processing...'}</span>
                            </Button>
                        </Col>
                    </Row>
                    <br />                    
                    <Row>
                        <Col span={24} className="ant-modal-footer si-ant">
                            <div className='ant-row' style={{ display: viewTracking ? 'none' : 'block', overflow: "scroll" }}>
                                <Table columns={columns} rowKey={(record: any) => record.patientId} dataSource={this.state.trackings} loading={loading} bordered />
                            </div>
                            <div className="ul-nfo custom-filter-dropdown  pt-list" style={{ display: viewTracking ? 'block' : 'none', overflow: 'scroll' }}>
                                <div className="ant-modal-content">
                                    <button title="Close" type="button" aria-label="Close" onClick={() => this.exitTrack()} className="ant-modal-close">
                                        <span className="ant-modal-close-x">
                                            <CloseCircleOutlined />
                                        </span>
                                    </button>
                                    <div className="ant-modal-header">
                                        <div className="hdr-h" style={{ fontSize: '23px !important' }}>
                                            {"NMRS Encounter ID:" + tracker.encounterId}
                                        </div>
                                    </div>
                                    <div className="ant-modal-body">
                                        <div className='ant-row'>
                                            <div className='ant-col-24 padding-md pt-details'>
                                                <div className="ant-row">
                                                    <div className="ant-col-6 padding-md">
                                                        <label>Patient Id:</label>
                                                        <h5>{(tracker.patientId && tracker.patientId !== null) ? tracker.patientId : ''}</h5>
                                                    </div>
                                                    <div className="ant-col-6 padding-md">
                                                        <label>Hospital Number:</label>
                                                        <h5>{(tracker.hospitalNumber && tracker.hospitalNumber !== null) ? tracker.hospitalNumber: ''}</h5>
                                                    </div>
                                                </div>
                                                <div className="ant-row">
                                                    <div className="ant-col-6 padding-md">
                                                        <label>Encounter Date:</label>
                                                        <h5>{(tracker.trackingEncounterDate && tracker.trackingEncounterDate !== null) ? tracker.trackingEncounterDate.replace('T00:00:00', '') : ''}</h5>
                                                    </div>
                                                </div>
                                                <div className="ant-row">
                                                    <Divider orientation="left"></Divider>
                                                    <div className="ant-col-6 padding-md">
                                                        <label>Date:</label>
                                                        <h5>{tracker.trackingEncounterDate}</h5>
                                                    </div>
                                                    <div className="ant-col-6 padding-md">
                                                        <label>Reason for Tracking:</label>
                                                        <h5>{tracker.reasonForTracking}</h5>
                                                    </div>
                                                    <div className="ant-col-6 padding-md">
                                                        <label>Guardian / Treatment Partner's Name:</label>
                                                        <h5>{tracker.guardianOrTreatmentPartnerName}</h5>
                                                    </div>
                                                    <div className="ant-col-6 padding-md">
                                                        <label>Guardian / Treatment Partner's Contact Address:</label>
                                                        <h5>{tracker.guardianTreatmentPartnerContactAddress}</h5>
                                                    </div>
                                                    <div className="ant-col-6 padding-md">
                                                        <label>Guardian / Treatment Partner's Phone Number:</label>
                                                        <h5>{tracker.guardianTreatmentPartnerPhoneNumber}</h5>
                                                    </div>
                                                    <div className="ant-col-6 padding-md">
                                                        <label>Date of Last Actual Contact/ Appointment:</label>
                                                        <h5>{tracker.dateOfLastActualContactAppointment}</h5>
                                                    </div>
                                                    <div className="ant-col-6 padding-md">
                                                        <label>Date of Missed Scheduled Appointment:</label>
                                                        <h5>{tracker.dateOfMissedScheduledAppointment}</h5>
                                                    </div>
                                                </div>
                                                <div className="ant-row">
                                                    <Divider orientation="left">Attempt to Contact</Divider>
                                                    <div className="ant-table-content">
                                                        <table style={{ tableLayout: 'auto' }}>
                                                            <colgroup></colgroup>
                                                            <thead className="ant-table-thead">
                                                                <tr>
                                                                    <th className="ant-table-cell">Attempt(s)</th>
                                                                    <th className="ant-table-cell">Date</th>
                                                                    <th className="ant-table-cell">Who Attempted Contact?</th>
                                                                    <th className="ant-table-cell">Mode of Communication</th>
                                                                    <th className="ant-table-cell">Person contacted</th>
                                                                    <th className="ant-table-cell">Reason for Defaulting</th>
                                                                </tr>
                                                            </thead>                                                            				
                                                            <tbody className="ant-table-tbody">
                                                                <tr data-row-key="1" className="ant-table-row ant-table-row-level-0">
                                                                    <td className="ant-table-cell">
                                                                        <label>a. 1st Attempted contact</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.datePatientContacted1}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.nameOfTracker1}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.modeOfCommunication1}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.personContacted1}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        {tracker.reasonForDefaulting1}
                                                                    </td>
                                                                </tr>     
                                                                <tr data-row-key="1" className="ant-table-row ant-table-row-level-0">
                                                                    <td className="ant-table-cell">
                                                                        <label>b. Other attempted contact</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.datePatientContacted2}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.nameOfTracker2}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.modeOfCommunication2}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.personContacted2}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        {tracker.reasonForDefaulting2}
                                                                    </td>
                                                                </tr>     
                                                                <tr data-row-key="1" className="ant-table-row ant-table-row-level-0">
                                                                    <td className="ant-table-cell">
                                                                        <label>c. Other attempted contact</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.datePatientContacted3}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.nameOfTracker3}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.modeOfCommunication3}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.personContacted3}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        {tracker.reasonForDefaulting3}
                                                                    </td>
                                                                </tr>    
                                                                <tr data-row-key="1" className="ant-table-row ant-table-row-level-0">
                                                                    <td className="ant-table-cell">
                                                                        <label>d. Other attempted contact</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.datePatientContacted4}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.nameOfTracker4}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.modeOfCommunication4}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.personContacted4}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        {tracker.reasonForDefaulting4}
                                                                    </td>
                                                                </tr>    
                                                                <tr data-row-key="1" className="ant-table-row ant-table-row-level-0">
                                                                    <td className="ant-table-cell">
                                                                        <label>e. Last attempted contact (By 28 days)</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.datePatientContacted5}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.nameOfTracker5}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.modeOfCommunication5}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        <label>{tracker.personContacted5}</label>
                                                                    </td>
                                                                    <td className="ant-table-cell">
                                                                        {tracker.reasonForDefaulting5}
                                                                    </td>
                                                                </tr>    
                                                            </tbody>
                                                        </table>
                                                        <br />
                                                    </div>
                                                </div>
                                                {tracker.lostToFollowUp !== null && tracker.lostToFollowUp.toLowerCase() === 'yes' &&
                                                <div className="ant-row">
                                                    <Divider orientation="left"></Divider>
                                                    <div className="ant-col-6 padding-md">
                                                        <label>Reason for Lost to follow up:</label>
                                                        <h5>{tracker.reasonForLostToFollowUp}</h5>
                                                    </div>
                                                    <div className="ant-col-6 padding-md">
                                                        <label>Date of Lost to follow up:</label>
                                                        <h5>{tracker.dateLTFU}</h5>
                                                    </div>
                                                </div>}
                                                {tracker.careTerminated !== null && tracker.careTerminated.toLowerCase() === 'yes' && <div className="ant-row">
                                                    <Divider orientation="left"></Divider>
                                                    <div className="ant-col-6 padding-md">
                                                        <label>Patient Care in Facility Terminated:</label>
                                                        <h5>{tracker.careTerminated}</h5>
                                                    </div>
                                                    <div className="ant-col-6 padding-md">
                                                        <label>Date of Termination:</label>
                                                        <h5>{tracker.dateCareTerminated}</h5>
                                                    </div>
                                                    <div className="ant-col-6 padding-md">
                                                        <label>Reason for Termination:</label>
                                                        <h5>{tracker.reasonForTermination}</h5>
                                                    </div>
                                                    {tracker.reasonForTermination !== null && tracker.reasonForTermination.toLowerCase() === 'transferred out to another facility' && <div className="ant-col-6 padding-md">
                                                        <label>Facility transferred to:</label>
                                                        <h5>{tracker.facilityTransferredTo}</h5>
                                                    </div>}
                                                    {tracker.reasonForTermination !== null && tracker.reasonForTermination.toLowerCase() === 'death' && <div className="ant-col-6 padding-md">
                                                        <label>Cause of death:</label>
                                                        <h5>{tracker.causeOfDeath}</h5>
                                                    </div>}
                                                    {tracker.reasonForTermination !== null && tracker.reasonForTermination.toLowerCase() === 'death' && <div className="ant-col-6 padding-md">
                                                        <label>Other Cause of death:</label>
                                                        <h5>{tracker.otherCauseOfDeath}</h5>
                                                    </div>}
                                                    {tracker.reasonForTermination !== null && tracker.reasonForTermination.toLowerCase() === 'discontinued care' && <div className="ant-col-6 padding-md">
                                                        <label>Reason to Discontinue Care:</label>
                                                        <h5>{tracker.reasonDiscontinuedCare}</h5>
                                                    </div>}
                                                </div>}

                                                {tracker.careTerminated !== null && tracker.careTerminated.toLowerCase() === 'no' && <div className="ant-row">
                                                    <Divider orientation="left"></Divider>
                                                    <div className="ant-col-6 padding-md">
                                                        <label>Date Returned to Care:</label>
                                                        <h5>{(tracker.dateReturnedToCare !== null && tracker.dateReturnedToCare.length > 0) ? tracker.dateReturnedToCare.replace('T00:00:00', '') : ''}</h5>
                                                    </div>
                                                    <div className="ant-col-6 padding-md">
                                                        <label>Referred for:</label>
                                                        <h5>{tracker.referredFor}</h5>
                                                    </div>
                                                </div>}

                                                <div className="ant-row">
                                                    <Divider orientation="left">Signature</Divider>
                                                    <div className="ant-col-6 padding-md">
                                                        <label>Name of Contact Tracker:</label>
                                                        <h5>{tracker.nameOfContactTracker}</h5>
                                                    </div>
                                                    <div className="ant-col-6 padding-md">
                                                        <label>Date:</label>
                                                        <h5>{(tracker.dateTracked !== null && tracker.dateTracked.length > 0) ? tracker.dateTracked.replace('T00:00:00', '') : ''}</h5>
                                                    </div>                                                 
                                                </div>
                                                <br />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>  

                </div>
            </div>
        )
    }
}

export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(Tracking as any);
